import { env } from '@accor/customer-core/env'
import { axiosApi } from '@accor/customer-core'
import {
  getContact as libGetContact,
  putContact as libPutContact,
  deleteContactItem as libDeleteContactItem
} from '@accor/customer-lib'
import { i18nService } from '@accor/customer-vue-services'

const CLIENT = 'customer-account'

// getAuthUrl compat: no-arg → plain sign-in; opts → sign-in with forwarded params (mfa etc.)
export const buildSignInUrl = (
  opts: {
    redirect?: string
    auth_method?: string
    acr_values?: string
    lang?: string
  } = {}
): string => {
  const url = new URL(env.config.permalinkSignIn)
  url.searchParams.set('client', CLIENT)
  url.searchParams.set('languageCode', opts.lang ?? i18nService.getCurrentLocale())
  if (opts.redirect) url.searchParams.set('redirect_site_uri', opts.redirect)
  if (opts.auth_method) url.searchParams.set('auth_method', opts.auth_method)
  if (opts.acr_values) url.searchParams.set('acr_values', opts.acr_values)
  return url.toString()
}

export const buildAllPlusUrl = (opts: {
  funnel: string
  lang?: string
  origin?: string
}): string => {
  const url = new URL(env.config.permalinkAllPlus)
  url.searchParams.set('client', CLIENT)
  url.searchParams.set('languageCode', opts.lang ?? i18nService.getCurrentLocale())
  url.searchParams.set('funnel', opts.funnel)
  if (opts.origin) url.searchParams.set('origin', opts.origin)
  return url.toString()
}

export const getLatamPlans = async () => {
  const { data } = await axiosApi.get('/latam/v1/plans?active=true')
  return data
}

type ContactHeaders = { origin?: string } & Record<string, unknown>
export const contactCompat = {
  getContact:
    (headers: ContactHeaders = {}) =>
    (opts: Record<string, unknown> = {}) =>
      libGetContact({ ...opts, ...(headers.origin ? { origin: headers.origin } : {}) }),
  putContact:
    (headers: ContactHeaders = {}) =>
    (opts: { service?: string; payload: unknown }) =>
      libPutContact({ ...opts, ...(headers.origin ? { origin: headers.origin } : {}) }),
  deleteContactItem:
    (headers: ContactHeaders = {}) =>
    (opts: { service: string; id?: string }) =>
      libDeleteContactItem({ ...opts, ...(headers.origin ? { origin: headers.origin } : {}) })
}
